import * as React from "react";
const SVGComponent = (props) => (
  <svg
  width={140 * 0.6}  // 20% reduction
  height={127 * 0.6} // 20% reduction
    viewBox="0 0 140 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M139.844 0.000236511C73.4959 13.4682 20.0127 62.364 0 126.082H125.844C133.576 126.082 139.844 119.814 139.844 112.082V0.000236511Z"
      fill="#0047AB"
    />
  </svg>
);
export default SVGComponent;
